
import { createSlice } from '@reduxjs/toolkit'
const currentStageSlice = createSlice({
  name: 'currentStageSlice',
  initialState: {
    value: '',
    currentStageValue: 0,
    isWidth: false,
    isTheme: 'dark',
    resetMapTrigger: false,
    isBufferWidth: false,
    isToolHeight: false,
    isSideBar: false,
    isYearLeft: 1,
    isYearRight:8,
    isDragTable:false,
  },
  reducers: {
    currentStageData: (state, action) => {
      state.currentStageValue = action.payload;
    },
    setIsWidth: (state, action) => {
      state.isWidth = action.payload;
    },
    setIsTheme: (state, action) => {
      state.isTheme = action.payload;
    },
    reSetMap: (state) => {
      state.resetMapTrigger = !state.resetMapTrigger;
    },
    setIsBufferWidth: (state, action) => {
      state.isBufferWidth = action.payload;
    },
    setIsToolsHeight: (state, action) => {
      state.isToolHeight = action.payload;
    },
    setIsSidebar: (state, action) => {
      state.isSideBar = action.payload;
    },
    setIsDist: (state, action) => {
      state.isDistCd = action.payload;
    },
    setIsUlb: (state, action) => {
      state.isUlbCd = action.payload;
    },
    setIsWard: (state, action) => {
      state.isWardNo = action.payload;
    },
    setIsYearLeft: (state, action) => {
      state.isYearLeft = action.payload;
    },
    setIsYearRight: (state, action) => {
      state.isYearRight = action.payload;
    },
     setIsDrgaTable: (state, action) => {
      state.isWidth = action.payload;
    },
  },
})

export const { currentStageData,setIsWidth,setIsTheme,reSetMap,setIsBufferWidth,setIsToolsHeight,setIsSidebar,setIsDist,setIsUlb,setIsWard,setIsYearRight,setIsYearLeft,setIsDrgaTable } = currentStageSlice.actions
export default currentStageSlice.reducer